import type { RequestConfig } from '@customTypes/index';
import type { WorkItemDto } from '@customTypes/types';

import { api } from '@/shared/api/instance';

export type ArtistAllWorkItemsRequest = {
  profileId: string;
};

export type ArtistAllWorkItemsParams = RequestConfig<ArtistAllWorkItemsRequest>;

export const artistAllWorkItems = async ({
  params,
  config
}: ArtistAllWorkItemsParams) =>
  api.get<WorkItemDto[]>(
    `/api/work/items/all/artist/${params.profileId}`,
    config
  );
